import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Table, Icon, Dropdown, Menu } from "antd";

import { useAxios } from "../../../../../shared/hooks/useAxios";

import UserInfo from "../../../UserInfo/UserInfo";
import InitialsAvatar from "../../../../../shared/components/InitialsAvatar";
import DrawerFaltasJustificadas from "../../../../../features/Turmas/Inscricoes/components/FaltasJustificadasDrawer";

const Matriculas = () => {
    const [alunos, setAlunos] = useState([]);
    const [visible, setVisible] = useState(false);
    const [alunoFaltasJustificadasInfo, setAlunoFaltasJustificadasInfo] = useState(undefined);

    const { loading, notAuthorized, fetchData } = useAxios();

    const listarAlunosMatriculados = async () => {
        const turmaInfo = JSON.parse(sessionStorage.getItem("turmaInfo"));

        const { error, data } = await fetchData({
            method: "get",
            url: "/api/gestao-turma-matriculas/alunos-matriculados",
            params: {
                turmaId: turmaInfo?.id
            }
        });

        if (!error) {
            setAlunos(data);
        } else {
        }
    };

    useEffect(() => {
        listarAlunosMatriculados();
    }, []);

    const columns = [
        {
            title: "Aluno",
            dataIndex: "nome",
            className: "td-curso",
            render: (text, record) => (
                <div className="aluno-info">
                    <div className="aluno-foto">
                        {record.foto ? <img src={record.foto} alt={text} /> : text !== "" && <InitialsAvatar name={text} />}
                    </div>
                    <div className="aluno-dados">
                        <span className="aluno-nome">{text}</span>
                        <span className="aluno-numero">{record.nrAluno}</span>
                    </div>
                </div>
            )
        },
        {
            title: "",
            dataIndex: "opcoes",
            className: "td-50",
            render: (text, record) => (
                <Dropdown
                    overlay={montarMenu(record)}
                    placement="bottomLeft"
                    onClick={event => event.stopPropagation()}
                    overlayStyle={{
                        zIndex: "9"
                    }}
                >
                    <Link to="#" className="botao-icon-configs">
                        <i className="fas fa-cog" />
                    </Link>
                </Dropdown>
            )
        }
    ];

    const montarMenu = aluno => {
        return (
            <Menu>
                <Menu.Item>
                    <Link to="#" onClick={e => abrirDrawerFaltasJutificadas(e, aluno)}>
                        Faltas Justificadas
                    </Link>
                </Menu.Item>
            </Menu>
        );
    };

    const abrirDrawerFaltasJutificadas = (e, aluno) => {
        e.stopPropagation();

        setAlunoFaltasJustificadasInfo({
            id: aluno.id,
            nome: aluno.nome,
            codigo: aluno.nrAluno
        });
        setVisible(true);
    };

    const turmaInfo = JSON.parse(sessionStorage.getItem("turmaInfo"));

    return (
        <>
            <div className="details-page" style={{ marginTop: 80 }}>
                <div className="page-container">
                    <UserInfo educacaoProfessor />
                    <div className="user-info-detail ajustar-ecra-centro">
                        <div className="page-info">
                            <div>
                                <h1 className="page-title" style={{ margin: "20px 20px 10px 20px" }}>
                                    Matriculas ({alunos.length}) - {turmaInfo?.nome}
                                </h1>
                            </div>

                            <span className="page-controls">
                                <Link
                                    to={"/utilizador-turmas"}
                                    className="botao-secundario botao-secundario-redondo"
                                    style={{ marginRight: 10, display: "flex", justifyContent: "center", alignItems: "center" }}
                                    onClick={() => {
                                        sessionStorage.removeItem("turmaInfo");
                                    }}
                                >
                                    <Icon type="arrow-left" />
                                </Link>
                            </span>
                        </div>
                        <div className="block-table">
                            <Table
                                className="tabela-user-disciplinas"
                                loading={{
                                    spinning: loading,
                                    indicator: (
                                        <div className="loading-data-table">
                                            <div className="loading" />
                                        </div>
                                    )
                                }}
                                columns={columns}
                                dataSource={alunos}
                                pagination={false}
                                locale={{ emptyText: "Não existem dados!" }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <DrawerFaltasJustificadas inscricao={alunoFaltasJustificadasInfo} visible={visible} onClose={() => setVisible(false)} />
        </>
    );
};

export default Matriculas;
